import { getColorValue } from "./getColorValue";

export const lerp = (x: number, y: number, a: number) => x * (1 - a) + y * a;

export const invlerp = (x: number, y: number, a: number) =>
	clamp((a - x) / (y - x));

export const clamp = (a: number, min = 0, max = 1) =>
	Math.min(max, Math.max(min, a));

export const interpolateRange = (
	x1: number,
	y1: number,
	x2: number,
	y2: number,
	a: number
) => lerp(x2, y2, invlerp(x1, y1, a));

export { getColorValue };
